import {Tooltip} from 'platform/components';

import {isNumber} from 'ramda-adjunct';

import {formatFileSize} from 'shared/web';

import {EMPTY_CELL_PLACEHOLDER} from '../../constants/cellPlaceholder';
import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getNumericCellClassName} from '../../utils/getCellClassName';
import {getTooltipProps} from '../../utils/getTooltipProps';

type FileSizeCellRendererProps = CellRendererProps<number | null> & {
  getTooltipProps?: TooltipGetter;
};

// Renders numeric byte values as a human-readable file size string (INTEGER
// columns with the FILE_SIZE renderer), like the legacy datagrid's
// FileSizeCellRenderer.
export function FileSizeCellRenderer(props: FileSizeCellRendererProps) {
  const className = getNumericCellClassName(props.isWrap);
  const tooltipProps = getTooltipProps(props.row, props.getTooltipProps);

  // Finite numbers only — formatFileSize(NaN) would render "NaN undefined"
  // (isNumber narrows the type; Number.isFinite rejects NaN/Infinity).
  if (!isNumber(props.value) || !Number.isFinite(props.value)) {
    return <div className={className}>{props.emptyCellValue ?? EMPTY_CELL_PLACEHOLDER}</div>;
  }

  const value = formatFileSize(props.value);

  return (
    <Tooltip {...tooltipProps} label={value}>
      <div className={className}>{value}</div>
    </Tooltip>
  );
}
